export enum BlogCategory {
    Coding = 1,
    Food = 2,
    Gaming = 3
}